import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';

@HimuraInject.NamedService('UserInfoDelegate')
export class UserInfoDelegate extends DataDelegate {

    private _userName: any = undefined;
    get Username(): any {
        return this._userName;
    }
    set Username(name: any) {
        this._userName = name;
    }

    private _userDetail: any = undefined;
    get UserDetail(): any {
        return this._userDetail;
    }
    set UserDetail(detail: any) {
        this._userDetail = name;
    }

    constructor() {
        super('UserInfoDelegate');
    }

    public async getRemoteUser(store: any, agentUrl: string = '') {
        const commonConfigs = new CommonConfig();
        const cmisapiHost: string = commonConfigs.cmisapiHost;
        const fetched: any = await AxiosPromise.get(`${cmisapiHost}/bimsUser/getAgentProfile?agentBlogUri=${agentUrl}`);
        if (T_T.simpleDetect(fetched) && fetched.code === 200) {
            this.Data = fetched.data;
            const userName = agentUrl.split('.')[0];
            this.Username = userName;
            store.commit('setUserName', userName);
            return 1;
        } else {
            return 0;
        }
    }
}
